import { createApiHandler } from './handler';

const expenses = {
  apiClient: null,
  path: '/admin/expenses',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

};

export default expenses;
